import React from 'react';
import css from './AuthModal.module.css';
import Modal from '../Modal/Modal';
import SignupForm from '../../containers/AuthenticationPage/SignupForm/SignupForm';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { authenticationInProgress, login, signup, signupWithIdp } from '../../ducks/auth.duck';
import { sendVerificationEmail } from '../../ducks/user.duck';
import { isScrollingDisabled, manageDisableScrolling } from '../../ducks/ui.duck';
import { useState } from 'react';
import LoginForm from '../../containers/AuthenticationPage/LoginForm/LoginForm';

const AuthModalComponent = props => {
  const [tab, setTab] = useState('login');
  const {
    isOpen,
    setOpen,
    isLogin,
    showFacebookLogin,
    showGoogleLogin,
    from,
    submitLogin,
    loginError,
    signupError,
    authInProgress,
    submitSignup,
    termsAndConditions,
    onManageDisableScrolling,
  } = props;

  const handleSubmitSignup = async values => {
    const { fname, lname, ...rest } = values;
    const params = { firstName: fname.trim(), lastName: lname.trim(), ...rest };
    await submitSignup(params);
    setOpen(false);
  };

  const handleLogin = async args => {
    await submitLogin(args);
    setOpen(false);
  };

  return (
    <Modal
      id="AuthModal"
      isOpen={isOpen}
      onClose={() => {
        setOpen(false);
      }}
      onManageDisableScrolling={onManageDisableScrolling}
    >
      <div className={css.wrapper}>
        <div className={css.tabsSwitcher}>
          <div
            onClick={() => setTab('login')}
            className={tab === 'login' ? css.tabSelected : css.tab}
          >
            Log in
          </div>
          <div
            onClick={() => setTab('signup')}
            className={tab !== 'login' ? css.tabSelected : css.tab}
          >
            Sign up
          </div>
        </div>
        <div className={css.formsWrapper}>
          {tab === 'login' ? (
            <LoginForm
              className={css.loginForm}
              onSubmit={handleLogin}
              inProgress={authInProgress}
            />
          ) : (
            <SignupForm
              className={css.signupForm}
              onSubmit={handleSubmitSignup}
              inProgress={authInProgress}
              termsAndConditions={termsAndConditions}
            />
          )}
        </div>
      </div>
    </Modal>
  );
};

const mapStateToProps = state => {
  const { isAuthenticated, loginError, signupError, confirmError } = state.auth;
  const { currentUser, sendVerificationEmailInProgress, sendVerificationEmailError } = state.user;
  const {
    pageAssetsData: privacyAssetsData,
    inProgress: privacyFetchInProgress,
    error: privacyFetchError,
  } = state.hostedAssets || {};
  const { pageAssetsData: tosAssetsData, inProgress: tosFetchInProgress, error: tosFetchError } =
    state.hostedAssets || {};

  return {
    authInProgress: authenticationInProgress(state),
    currentUser,
    isAuthenticated,
    loginError,
    scrollingDisabled: isScrollingDisabled(state),
    signupError,
    confirmError,
    sendVerificationEmailInProgress,
    sendVerificationEmailError,
    privacyAssetsData,
    privacyFetchInProgress,
    privacyFetchError,
    tosAssetsData,
    tosFetchInProgress,
    tosFetchError,
  };
};

const mapDispatchToProps = dispatch => ({
  submitLogin: ({ email, password }) => dispatch(login(email, password)),
  submitSignup: params => dispatch(signup(params)),
  submitSingupWithIdp: params => dispatch(signupWithIdp(params)),
  onResendVerificationEmail: () => dispatch(sendVerificationEmail()),
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
});

const AuthModal = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl
)(AuthModalComponent);

export default AuthModal;
